export default "__VITE_ASSET__BTsQfO5j__"